import extraLazy from 'shared/extraLazy';
export default extraLazy(() => import(/* webpackChunkName: "replay" */ 'shared/symbols/Replay'));
